import { Box } from '@mui/material';
import React from 'react';
import Header from '../components/Header';
import { FooterNew } from '../components/organisms';

/**
 * Layout component for legal pages with consistent header and footer
 *
 * This component provides a consistent layout structure for all legal/informational pages:
 * - Standard header with empty scroll functions (legal pages don't need scrolling)
 * - Main content area that grows to fill available space
 * - Standard footer
 * - Proper flex layout for full viewport height
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The page content to render
 * @returns {React.ReactElement} The legal page layout
 */
function LegalPageLayout({ children }) {
  return (
    <Box
      sx={{
        textAlign: 'left',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header
        scrollToCollective={() => {}}
        scrollToServices={() => {}}
        scrollToContact={() => {}}
      />
      <Box component="main" sx={{ flex: 1 }}>
        {children}
      </Box>
      <FooterNew />
    </Box>
  );
}

export default LegalPageLayout;
